import React, { FC, memo } from 'react';

import { DATA_TEST_IDS } from '../../consts';
import PromoOptionsList from '../PromoOptionsList';
import PromoSelectionHeader from '../PromoSelectionHeader';
import PromoSelectorSearchRow from '../../../ReportRequestForm/PromoSelector/PromoSelectorSearchRow';
import type { PromoSelectorDropdownProps } from '../types';

import styles from './index.module.scss';

const PromoSelectorDropdown: FC<PromoSelectorDropdownProps> = ({
  dropdownId,
  dropdownStyle,
  filterButtonRef,
  filterContainerRef,
  hasNextPage,
  isFilterOpen,
  isInitialLoading,
  isNextPageLoading,
  isBulkSelectionActionPending,
  isSelectionActionPending,
  items,
  queryError,
  queryKey,
  search,
  selectedCount,
  selectedStatuses,
  sort,
  statusesInfo,
  totalCount,
  onFilterToggle,
  onLoadMore,
  onSearchChange,
  onPromoPlaybackToggle,
  onPromoSelectionChange,
  onReset,
  onSelectAll,
  onRetry,
  onSortToggle,
  onStatusChange,
}) => {
  const isEmpty = !isInitialLoading && !queryError && items.length === 0;

  return (
    <div
      id={dropdownId}
      className={styles.dropdown}
      data-testid={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_DROPDOWN}
      style={dropdownStyle}>
      <PromoSelectorSearchRow
        filterButtonRef={filterButtonRef}
        filterContainerRef={filterContainerRef}
        isFilterOpen={isFilterOpen}
        search={search}
        selectedStatuses={selectedStatuses}
        sort={sort}
        statusesInfo={statusesInfo}
        onFilterToggle={onFilterToggle}
        onSearchChange={onSearchChange}
        onSortToggle={onSortToggle}
        onStatusChange={onStatusChange}
      />
      <div
        className={styles.divider}
        data-testid={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_DIVIDER}
      />
      {!isEmpty && (
        <PromoSelectionHeader
          hasUnselectedPromos={selectedCount < totalCount && (items.some((item) => !item.isSelected) || hasNextPage)}
          isSelectionActionPending={isInitialLoading || isSelectionActionPending}
          selectedCount={selectedCount}
          onSelectAll={onSelectAll}
          onReset={onReset}
        />
      )}
      <PromoOptionsList
        hasNextPage={hasNextPage}
        isInitialLoading={isInitialLoading}
        isNextPageLoading={isNextPageLoading}
        isBulkSelectionActionPending={isBulkSelectionActionPending}
        items={items}
        queryError={queryError}
        queryKey={queryKey}
        onLoadMore={onLoadMore}
        onPromoPlaybackToggle={onPromoPlaybackToggle}
        onPromoSelectionChange={onPromoSelectionChange}
        onRetry={onRetry}
      />
    </div>
  );
};

export default memo(PromoSelectorDropdown);
